export var AllRowsSelectedMessage = "All rows got selected";
export var AllRowsUnselectedMessage = "All rows got unselected";
export var ClickableRowAnnouncement = "Row {0}. Clickable";
export var ClickableRowAnnouncementWithSize = "Row {0} of {1}. Clickable";
export var ColumnSizerLabel = "{0} column sizer";
export var ColumnSortedAscendingAnnouncement = "Column sorted ascending";
export var ColumnSortedDescendingAnnouncement = "Column sorted descending";
export var EmptyColumnHeaderLabel = "Blank";
export var ListItem = "listitem";
export var MoreActions = "More actions";
export var MoreTooltip = "More options";
export var NoMoreActions = "No actions";
export var RemovePillLabel = "Remove {0}";
export var RowAnnouncement = "Row {0}";
export var RowAnnouncementWithSize = "Row {0} of {1}";
export var SelectAllRowsLabel = "Select all rows";
export var SelectionColumnLabel = "Selection column";
export var SelectRowLabel = "Select row";
export var ShowLess = "Show less";
export var ShowMore = "Show more";
export var SizerLabel = "Current value {0}, minimum value {1}, maximum value {2}";
export var SizerValueChanged = "New size value {0}";
export var Started = "Started {0}";
export var VirtualizationDisabled = "Virtualization disabled";
export var VirtualizedListLabelFormat = "{0}. Use ctrl + alt + v to disable list virtualization";
